module.exports = __webpack_public_path__ + "img/JPY-USD.db50ee11.png";